// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 599px) {
  .mail-drafts-dialog {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .mail-drafts-dialog {
    width: 70%;
  }
}
.mail-drafts-dialog .mat-mdc-dialog-container {
  padding: 0;
}
.mail-drafts-dialog .dialog-content-wrapper {
  max-height: 85vh;
  display: flex;
  flex-direction: column;
}
.mail-drafts-dialog .products-table {
  z-index: 0;
  flex: 1 1 auto;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
.mail-drafts-dialog .products-table .mat-mdc-header-row {
  min-height: 64px;
}
.mail-drafts-dialog .products-table .mat-mdc-cell {
  min-width: 0;
  display: flex;
  align-items: center;
}
.mail-drafts-dialog .products-table .mat-column-action {
  flex: 0 1 80px;
}
.mail-drafts-dialog .products-table .mat-mdc-column-date {
  flex: 0 1 80px;
}
.mail-drafts-dialog .loading-shade {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.15);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/@fuse/scss/partials/_breakpoints.scss","webpack://./src/app/directives/compose-email/email-drafts/email-drafts.component.scss"],"names":[],"mappings":"AAiCQ;EC/BR;IAEQ,WAAA;EADN;AACF;AD6BQ;EC/BR;IAMQ,UAAA;EAAN;AACF;AAEI;EACI,UAAA;AAAR;AAGI;EACI,gBAAA;EACA,aAAA;EACA,sBAAA;AADR;AAII;EACI,UAAA;EACA,cAAA;EACA,4CAAA;EACA,cAAA;EACA,iCAAA;AAFR;AAIQ;EACI,gBAAA;AAFZ;AAKQ;EACI,YAAA;EACA,aAAA;EACA,mBAAA;AAHZ;AAMQ;EACI,cAAA;AAJZ;AAOQ;EACI,cAAA;AALZ;AASI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,+BAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAPR","sourcesContent":["// Media step breakpoint mixin based on Angular Material lib\n$breakpoints: (\n    xs: 'screen and (max-width: 599px)',\n    sm: 'screen and (min-width: 600px) and (max-width: 959px)',\n    md: 'screen and (min-width: 960px) and (max-width: 1279px)',\n    lg: 'screen and (min-width: 1280px) and (max-width: 1919px)',\n    xl: 'screen and (min-width: 1920px) and (max-width: 5000px)',\n    lt-sm: 'screen and (max-width: 599px)',\n    lt-md: 'screen and (max-width: 959px)',\n    lt-lg: 'screen and (max-width: 1279px)',\n    lt-xl: 'screen and (max-width: 1919px)',\n    gt-xs: 'screen and (min-width: 600px)',\n    gt-sm: 'screen and (min-width: 960px)',\n    gt-md: 'screen and (min-width: 1280px)',\n    gt-lg: 'screen and (min-width: 1920px)'\n) !default;\n\n// Re-map the breakpoints for the helper classes\n$helper-breakpoints: (\n    xs: null,\n    sm: 'gt-xs',\n    md: 'gt-sm',\n    lg: 'gt-md',\n    xl: 'gt-lg'\n);\n\n@mixin media-breakpoint($breakpointName) {\n\n    $mediaQuery: map-get($breakpoints, $breakpointName);\n\n    @if ($mediaQuery == null) {\n        @content\n    } @else {\n        @media #{$mediaQuery} {\n            @content\n        }\n    }\n}\n","@import \"src/@fuse/scss/partials/breakpoints\";\n\n.mail-drafts-dialog {\n    @include media-breakpoint('xs') {\n        width: 100%;\n    }\n\n    @include media-breakpoint('gt-xs') {\n        width: 70%;\n    }\n\n    .mat-mdc-dialog-container {\n        padding: 0;\n    }\n\n    .dialog-content-wrapper {\n        max-height: 85vh;\n        display: flex;\n        flex-direction: column;\n    }\n\n    .products-table {\n        z-index: 0;\n        flex: 1 1 auto;\n        border-bottom: 1px solid rgba(0, 0, 0, .12);\n        overflow: auto;\n        -webkit-overflow-scrolling: touch;\n\n        .mat-mdc-header-row {\n            min-height: 64px;\n        }\n\n        .mat-mdc-cell {\n            min-width: 0;\n            display: flex;\n            align-items: center;\n        }\n\n        .mat-column-action {\n            flex: 0 1 80px;\n        }\n\n        .mat-mdc-column-date {\n            flex: 0 1 80px;\n        }\n    }\n\n    .loading-shade {\n        position: absolute;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        background: rgba(0, 0, 0, 0.15);\n        z-index: 1000;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
